module.exports = __webpack_public_path__ + "static/media/creative-logo1(3).2ddbf43b.png";